export const HeroCardStyles = Object.freeze({
  DARK: 'dark',
  WITH_EVENT: 'withArtistEvents',
  WITH_LYRICS: 'withLyricSnippet',
} as const);
